<!-- eslint-disable keyword-spacing -->
<template lang="pug">
section.territorio
    BaseHeader#cadastrar-territorio(
        :titulo='$t("mensagens.territorio.labels.territorio")',
        icon='el-icon-plus',
        :btnTexto='$t("mensagens.territorio.cadastrarTerritorio")',
        :exibeBotao='true',
        @btnHeaderClicado='cadastrarTerritorio'
    )

    .view-container-base-header
        ModalTerritorioAdicionadoAR(
            :show='showModalTerritorioAdicionado',
            @close='closeModalTerritotorioAdicionado'
        )
        ModalNotificacaoAR(
            :show='showModalNotificacao',
            :idTerritorio='idTerritorioSelecionadoDeletar',
            @close='openAndcloseModalNotificacao'
        )

        .d-flex
            .lista-territorios__barra-pesquisa
                i.el-icon-search
                input.lista-territorios__barra-pesquisa__input(
                    v-model='search',
                    type='text',
                    :placeholder='$t("mensagens.territorio.procurePeloTerritorioArgentina")',
                    autocomplete='off'
                )

            //- el-dropdown.action-button(trigger='click')
            //-     el-button.btn-exportar-relatorio(
            //-         icon='el-icon-download',
            //-         type='primary'
            //-     ) &nbsp;&nbsp;&nbsp; {{ $t('mensagens.exportacao.exportar') }}
            //-     el-dropdown-menu(slot='dropdown')
            //-         el-dropdown-item(
            //-             icon='el-icon-download',
            //-             @click.native='exportarRelatorio(true)'
            //-         ) {{ $t('mensagens.exportacao.simples') }}
            //-         el-dropdown-item(
            //-             icon='el-icon-download',
            //-             @click.native='exportarRelatorio(false)'
            //-         ) {{ $t('mensagens.exportacao.completa') }}
        .table
            table.tabela-territorios(:key="listagemTableKey('territorios', territorios, paginacao.paginaAtual)", height='100%', style='width: 100%')
                template(v-if='territorios.length > 0')
                    .terrotorios-header
                        th
                        th {{ $t('mensagens.territorio.labels.codigoLyra') }}
                        th {{ isAlvorada ? 'Fazenda' : $t('mensagens.territorio.labels.territorio') }}
                        th {{ $t('mensagens.territorio.labels.areaHa') }}
                        th {{ $t('mensagens.territorio.territorioArgentina.dataRegistro') }}
                        th {{ $t('mensagens.territorio.labels.provincia') }}
                        th {{ $t('mensagens.territorio.labels.departamento') }}
                        th {{ $t('mensagens.territorio.labels.renspa') }}
                        th {{ $t('mensagens.territorio.labels.idInterno') }}
                        th {{ $t('mensagens.comuns.acoes') }}

                    .territorios-body(v-for='territorio in territorios')
                        .tbody
                            td
                                span.dropdown(
                                    @click='toggleDropdownTable(territorio.id)'
                                )
                                    i.mdi(
                                        :class='territoriosDropdownOpen.includes(territorio.id) ? "mdi-chevron-down" : "mdi-chevron-right"'
                                    )
                            td {{ verificarValorLabel(territorio.codigoLyra) }}
                            td {{ verificarValorLabel(territorio.nome) }}
                            td {{ verificarValorLabel(territorio.areaHa?.toFixed(3)) }}
                            td {{ verificarValorLabel(territorio.dataCadastroFormatada) }}
                            td {{ verificarValorLabel(territorio.provinciaNome) }}
                            td {{ verificarValorLabel(territorio.departamentoNomeAR) }}
                            td {{ formatarRenspa(territorio.renspa) }}
                            td {{ verificarValorLabel(territorio.idInterno) }}
                            td
                                el-dropdown.action-button(
                                    @click.native='setAtivo(territorio)',
                                    trigger='click'
                                )
                                    span.el-dropdown-link
                                        i.mdi.mdi-dots-vertical
                                    el-dropdown-menu(slot='dropdown')
                                        el-dropdown-item(
                                            icon='el-icon-view',
                                            @click.native='goToTerritorioDashboard(territorio)'
                                        ) {{ $t('mensagens.operacao.acoes.visualizar') }}

                                        el-dropdown-item(
                                            icon='el-icon-edit',
                                            @click.native='handleClickUpdate(territorio)'
                                        ) {{ $t('mensagens.operacao.acoes.editar') }}

                                        el-dropdown-item(
                                            icon='el-icon-delete',
                                            @click.native='handleClickDelete(territorio)'
                                        ) {{ $t('mensagens.operacao.acoes.remover') }}

                                        el-dropdown-item(
                                            v-if='false',
                                            icon='el-icon-map-location',
                                            @click.native='handleClickSendToMonitormaneto(territorio)'
                                        ) {{ verificaMonitoramento }}

                                        el-dropdown-item(
                                            v-if='false',
                                            icon='flow flow-environment',
                                            @click.native='goToDiagnosticoSocioambiental(territorio)'
                                        ) {{ $t('mensagens.diagnosticoSocioambiental.titulo') }}

                                        el-dropdown-item(
                                            v-if='!usuarioLogado.operacaoCadastrante',
                                            icon='el-icon-download',
                                            @click.native='baixarKMLTerritorio(territorio)'
                                        ) {{ $t('mensagens.territorio.baixarPoligono') }}

                        .content-dropdown(
                            v-if='territoriosDropdownOpen.includes(territorio.id)'
                        )
                            .content
                                strong {{ $t('mensagens.territorio.territorioArgentina.pessoa') }}: <span>{{ verificarValorLabel(territorio?.representantes[0]?.nomeRazaoSocial) }}</span>
                                strong {{ $t('mensagens.territorio.territorioArgentina.papelPessoa') }}: <span>{{ verificarValorLabel(territorio?.representantes[0]?.papel?.nome) }}</span>
                                strong {{ $t('mensagens.territorio.labels.cuit') }}: <span>{{ formatarCuit(territorio?.representantes[0]?.documento) }}</span>

                template(v-else)
                    el-empty(
                        :description='$t("mensagens.territorio.voceNaoPossuiTerritoriosCadastrados")'
                    )

            .tabela-rodape.paginacao-direita(v-if='territorios.length > 0')
                .tabela-rodape--esquerda
                    p {{ $t('mensagens.territorio.territorio') }}: {{ totalTerritorios }}

                .tabela-rodape--pagination
                    el-pagination(
                        background,
                        :page-size='paginacao.tamanhoPagina',
                        :current-page.sync='paginacao.paginaAtual',
                        layout='prev, pager, next',
                        :total='totalTerritorios',
                        @current-change='fetchTerritorios'
                    )

    #modal-delete-territorio-are-you-sure.row(v-if='deleteTerritorioModal')
        el-dialog(:visible.sync='deleteTerritorioModal', width='500px')
            span(slot='title')
                h1.mb-2.font-weight-bold(style='text-align: left') {{ $t('mensagens.territorio.removerTerritorio') }}
            .column.d-flex.justify-content-center.align-items-center.flex-column
                p.mb-5.texto-modal(v-if='statusMonitoramento === "ATIVO"')
                    | {{ $t('mensagens.territorio.naoFoiPossivelRemoverTerritorioEmMonitoramento') }}

                p.mb16.texto-modal(
                    v-else-if='statusMonitoramento === "CANCELADO"'
                )
                    b.mb-2 Atenção!
                    br
                    | {{ $t('mensagens.territorio.territorioPossuiMonitoramentosCancelados') }}

                p.mb16.texto-modal(v-else)
                    | {{ $t('mensagens.territorio.desejaRemoverTerritorio') }}

                .buttons.mb16(v-show='statusMonitoramento !== "ATIVO"')
                    el-button(
                        size='mini',
                        @click='handleCloseModalDeleteTerritorio'
                    )
                        | {{ $t('mensagens.comuns.cancelar') }}
                    el-button(
                        type='primary',
                        size='mini',
                        @click='deleteTerritorio'
                    )
                        | {{ $t('mensagens.comuns.remover') }}

    SendOrEditMonitoramento(
        v-if='showMonitoramentoModal',
        :showMonitoramentoModal='showMonitoramentoModal',
        :selectedTerritorioNome='selectedTerritorio.nome',
        :selectedTerritorio='territorioParaMonitoramento',
        actionType='send'
    )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import EmptyResult from '@/components/EmptyResult';
import SendOrEditMonitoramento from '@/components/areamonitorada/SendOrEditMonitoramento';
import ModalTerritorioAdicionadoAR from '@/components/territorio/ModalTerritorioAdicionadoAR';
import ModalNotificacaoAR from '@/components/territorio/ModalNotificacaoAR';
import { required } from 'vuelidate/lib/validators';
import territorioService from '@/services/TerritorioService';
import MonitoramentoService from '@/services/MonitoramentoService';
import debounce from 'lodash/debounce';
import { mapActions, mapGetters, mapState } from 'vuex';
import UtilsService from '@/services/UtilsService';
import { isEmpty } from 'lodash';
import formatters from '@/utils/formatters';

export default {
    name: 'index',
    components: {
        BaseHeader,
        EmptyResult,
        SendOrEditMonitoramento,
        ModalTerritorioAdicionadoAR,
        ModalNotificacaoAR
    },
    watch: {
        search: debounce(async function () {
            this.paginacao.paginaAtual = 1;
            await this.fetchTerritorios();
        }, 1000)
    },
    data() {
        return {
            isDropdownNotificationsOpen: false,
            visible: false,
            territorios: [],
            totalTerritorios: 0,
            paginacao: {
                paginaAtual: 1,
                tamanhoPagina: 10
            },
            territoriosDropdownOpen: [],
            territoriosPendentesAprovacao: [],
            showModalTerritorioAdicionado: false,
            idTerritorioSelecionadoDeletar: null,
            showModalNotificacao: false,
            search: null,
            deleteTerritorioModal: false,
            selectedTerritorio: {},
            territorioParaMonitoramento: {
                idTerritorio: null,
                cultura: null,
                dataPlantio: null,
                areaDoPlantio: null,
                idSafra: null,
                produtividade: null
            },
            statusMonitoramento: '',
            order: null,
            nomeColumn: null,
            verificaMonitoramento: false
        };
    },
    validations: {
        territorio: {
            nomeTerritorio: {
                required
            }
        },
        territorioParaMonitoramento: {
            idSafra: { required }
        }
    },

    created() {
        this.fetchTerritorios();
        this.resetTerritorio();
        this.clearTerritoryTableData();
    },
    filters: {
        formatarAreaDuasCasas: function (value) {
            if (!value) return '';
            const valueString = value.toString();
            return (
                Math.round(Number(valueString.replace(',', '.')) * 100) / 100
            ).toFixed(2);
        }
    },

    computed: {
        ...mapGetters([
            'showMonitoramentoModal',
            'territorioData',
            'usuarioLogado',
            'isAlvorada'
        ]),
        ...mapState(['usuarioLogado'])
    },

    methods: {
        ...mapActions([
            'setTerritorio',
            'clearTerritorio',
            'clearTerritoryTableData',
            'changeShowMonitoramentoModal'
        ]),
        getRepresentante(representantes) {
            if (representantes.length === 0) {
                return '-';
            }
            return representantes[0].cpfCnpj;
        },

        toggleDropdown() {
            this.isDropdownNotificationsOpen =
                !this.isDropdownNotificationsOpen;
        },

        toggleDropdownTable(id) {
            const territorioOpen = this.territoriosDropdownOpen.includes(id);
            if (territorioOpen) {
                this.territoriosDropdownOpen =
                    this.territoriosDropdownOpen.filter(
                        idTerritorio => idTerritorio !== id
                    );
            } else {
                this.territoriosDropdownOpen.push(id);
            }
        },

        goToTerritorioAr(idTerritorio) {
            this.$router.push({
                name: 'VizualizarTerritorioValidacaoAR',
                params: { idTerritorio }
            });
        },

        permissaoAmbiente(ambiente) {
            return this.usuarioLogado.ambienteLogado === ambiente;
        },

        async exportarRelatorio(simplificado) {
            const url = 'territorios/exportar/' + simplificado;
            UtilsService.baixarArquivo(url);
        },

        resetTerritorio() {
            this.$v.$reset();
            this.territorio = {};
        },

        async setAtivo(value) {
            if (this.usuarioLogado.monitoramentoAccess) {
                const response = await MonitoramentoService.verificarTerritorio(
                    value.id
                );
                const data = await response.data;
                if (!isEmpty(data)) {
                    this.verificaMonitoramento = this.$t(
                        'mensagens.territorio.atualizarMonitoramento'
                    );
                } else {
                    this.verificaMonitoramento = this.$t(
                        'mensagens.territorio.enviarParaMonitoramento'
                    );
                }
            }
        },
        async fetchTerritorios(novaPagina) {
            if (novaPagina !== undefined) {
                this.paginacao.paginaAtual = novaPagina;
            }
            let filtro = this.getFiltros();
            const { data } =
                await territorioService.territoriosArgentinaVizualizar(filtro);
            this.totalTerritorios = data.totalResultados;
            this.territorios = data.resultados;
        },

        async handlePageChange(page) {
            this.paginacao.paginaAtual = page;
            await this.fetchTerritorios();
        },

        cadastrarTerritorio() {
            this.territorioData.value = 'add';
            this.$router.push({ name: 'CadastroTerritorioArgentina' });
        },

        goToTerritorioDashboard(territorio) {
            this.$router.push({
                name: 'VisualizarTerritorio',
                params: { idTerritorio: territorio.id }
            });
        },

        closeModalTerritotorioAdicionado() {
            this.showModalTerritorioAdicionado = false;
        },

        openAndcloseModalNotificacao(idTerritorio) {
            this.idTerritorioSelecionadoDeletar = idTerritorio;
            this.showModalNotificacao = !this.showModalNotificacao;
        },

        handleClickUpdate(value) {
            this.$router.push({
                name: 'CadastrarEditarTerritorio',
                query: { id: value.id }
            });
        },

        deleteTerritorio() {
            territorioService
                .deleteAR(this.selectedTerritorio.id)
                .then(response => {
                    if (response.status === 200) {
                        this.deleteTerritorioModal = false;

                        this.fetchTerritorios();

                        this.$notify.success({
                            message: this.$t(
                                'mensagens.territorio.removidoComSucesso'
                            )
                        });
                    } else {
                        this.$notify.error({
                            message: this.$t(
                                'mensagens.territorio.erroAoRemoverTerritorioDevidoCalculoDeProdutividade'
                            )
                        });
                    }
                });
        },

        async handleClickDelete(territorio) {
            try {
                //                const { data } = await territorioService.getStatusMonitoramento(
                //                    territorio.id
                //                );

                //                this.statusMonitoramento = data;
                this.selectedTerritorio.id = territorio.id;
                this.deleteTerritorioModal = true;
            } catch {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.territorio.erroAoVerificarStatusMonitoramentos'
                    )
                });
            }
        },

        handleCloseModalDeleteTerritorio() {
            this.deleteTerritorioModal = false;
        },

        handleClickSendToMonitormaneto(territorio) {
            this.selectedTerritorio = territorio;
            this.territorioParaMonitoramento.idTerritorio =
                this.selectedTerritorio.id;
            this.changeShowMonitoramentoModal();
        },

        goToDiagnosticoSocioambiental(territorio) {
            this.$router.push({
                name: 'TerritorioSocioambiental',
                params: { idTerritorio: territorio.id }
            });
        },

        baixarKMLTerritorio(territorio) {
            territorioService.findById(territorio.id).then(({ data }) => {
                UtilsService.baixarKMLdeGeometria(data.geometria);
            });
        },

        formatarCuit(cuit) {
            return formatters.formatarCuit(cuit);
        },

        formatarRenspa(renspa) {
            if (!renspa) return '-';
            if (renspa.length !== 13) return renspa;
            return `${renspa.slice(0, 2)}.${renspa.slice(2, 5)}.${renspa.slice(
                5,
                6
            )}.${renspa.slice(6, 11)}/${renspa.slice(11)}`;
        },

        verificarValorLabel(valor) {
            if (valor) {
                return valor;
            }

            return '-';
        },

        getFiltros() {
            const filtro = {};
            filtro.size = this.paginacao.tamanhoPagina;
            filtro.page = this.paginacao.paginaAtual - 1;
            filtro.search = String(this.search || '').replace(
                /[^a-zA-Z0-9 ]/g,
                ''
            );

            filtro.order = '&sort=data_cadastro,desc';

            return filtro;
        }
    }
};
</script>

<style lang="scss" scoped>
.territorio {
    padding-top: 0 !important;
    height: 100%;
    width: 100%;
    overflow-y: auto;

    button {
        width: fit-content;
        cursor: pointer;
    }

    .fazendas-notificacao {
        width: 100%;
        display: flex;
        flex-direction: column;
        border: 1px solid #ddac44;
        border-radius: 5px;
        background: white;
        margin-bottom: 20px;
        .header-dropdown {
            display: flex;
            align-items: center;
            border-bottom: 1px solid #ddac44;
            gap: 15px;
            .icon {
                padding: 10px 20px;
                background: #ddac44;
                i {
                    color: white;
                }
            }
            strong {
                font-size: 22px;
                font-weight: 500;
                font-family: 'Roboto';
                color: #3b3b3b;
            }
            .text {
                font-size: 14px;
                font-weight: 500;
                color: #3b3b3b;
            }
            .dropdown {
                font-size: 20px;
                margin-left: auto;
                margin-right: 20px;
                cursor: pointer;
            }
        }
        .body-dropdown {
            display: flex;
            flex-direction: column;
            gap: 10px;
            justify-content: center;
            align-items: center;
            padding: 15px 40px;
            .el-table {
                padding-bottom: 10px;
                border-bottom: 1px solid #eeeeee;
                .el-table__header {
                    th {
                        text-align: start !important;
                        border-bottom: none !important;
                        div {
                            font-size: 12px;
                            font-weight: 500;
                            font-family: Roboto;
                            color: #3b3b3b;
                        }
                    }
                }
                .el-table__body-wrapper {
                    tr:hover > td.el-table__cell {
                        background: unset !important;
                    }
                    td {
                        text-align: start !important;
                        border: none !important;
                        padding: 0 !important;
                        div {
                            font-size: 14px;
                            font-weight: 500;
                            font-family: Roboto;
                            color: #3b3b3b;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            gap: 5px;
                            button {
                                border: 0;
                                padding: 0;
                                background-color: unset;
                                i {
                                    font-size: 16px;
                                }
                            }
                            .view {
                                color: #1c1b1f;
                            }
                            .success {
                                color: #266728;
                            }
                            .reject {
                                color: #dc362e;
                            }
                        }
                    }
                }
            }
            .ver {
                background: none;
                border: 0;
                color: #4294ec;
                display: flex;
                align-items: center;
                gap: 5px;
                &:hover {
                    outline: none !important;
                }
                span {
                    font-size: 14px;
                    font-family: 'Roboto';
                    font-weight: 500;
                }
            }
        }
    }

    .lista-territorios__barra-pesquisa {
        margin-right: 0px;
        width: 100%;
        height: 46px;
        border-radius: 5px;
        color: var(--primary);
        margin-bottom: 20px;
        display: flex;
        justify-content: center;
        box-shadow: 0 1px 5px 0 var(--block-shadow);
        background-color: var(--white);

        i.el-icon-search {
            color: var(--gray);
            font-size: 16px;
            display: flex;
            align-items: center;
            margin: 0 8px;
        }

        .lista-territorios__barra-pesquisa__input {
            width: 100%;
            height: 100%;
            border: none;
            outline: none;
            border-radius: 5px;
            color: var(--primary);
        }
    }

    .tabela-territorios {
        width: 100%;
        min-width: 1340px;
        background-color: white;
        display: flex;
        flex-direction: column;
        overflow-y: scroll;
        border-radius: 5px;
        .terrotorios-header,
        .tbody {
            width: 100%;
            display: grid;
            grid-template-columns:
                45px
                minmax(180px, 1.4fr)
                minmax(110px, 0.9fr)
                minmax(130px, 1fr)
                minmax(140px, 1fr)
                minmax(150px, 1fr)
                minmax(140px, 1fr)
                minmax(130px, 0.9fr)
                minmax(120px, 0.9fr)
                72px;
            border-bottom: 1px solid #eeeeee;
        }
        .terrotorios-header th {
            font-size: 14px;
            color: #183b57;
            font-weight: 500;
            font-family: Roboto;
        }
        .terrotorios-header th:nth-last-child(1),
        .terrotorios-header th:last-child {
            align-content: center;
            text-align: center;
        }
        .territorios-body {
            width: 100%;
            display: flex;
            flex-direction: column;
            .tbody td {
                border-top: 0 !important;
                font-size: 14px;
                color: #3b3b3b;
                font-weight: 400;
                font-family: Roboto;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                .dropdown {
                    cursor: pointer;
                }
            }
            .tbody td:last-child,
            .tbody td:nth-last-child(1) {
                align-content: center;
                text-align: center;
                white-space: nowrap;
            }
            .tbody .aprovado {
                padding: 3px 5px;
                border: 1px solid #c0ddc1;
                width: fit-content;
                margin: auto;
                color: #1f5b21;
                border-radius: 5px;
                background: #ebf4eb;
            }
            .tbody .reprovado {
                padding: 3px 5px;
                border: 1px solid #f4c1be;
                width: fit-content;
                margin: auto;
                color: #991f1a;
                border-radius: 5px;
                background: #fcebea;
            }
            .tbody .espera {
                padding: 3px 5px;
                border: 1px solid #e0e0e0;
                width: fit-content;
                margin: auto;
                color: #525252;
                border-radius: 5px;
                background: #f5f5f5;
            }
            .content-dropdown {
                width: 100%;
                display: flex;
                flex-direction: column;
                gap: 10px;
                .content {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    gap: 25px;
                    padding: 12px 0;
                    border-bottom: 1px solid #eeeeee;
                    padding: 12px 55.5px;
                    strong {
                        font-size: 14px;
                        font-weight: 400;
                        font-family: Roboto;
                        color: #3b3b3b;
                        span {
                            font-weight: 500;
                        }
                    }
                }
            }
        }
    }

    .btn-exportar-relatorio {
        width: 200px;
        height: 46px;
    }

    .required-text {
        color: var(--danger);
    }

    #end-add-territorio-button {
        p {
            cursor: pointer;
        }
    }

    .el-table {
        border-radius: 5px 5px 0 0 !important;

        .cell {
            word-break: break-word !important;
        }

        .action-button {
            cursor: pointer;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            white-space: nowrap;
        }

        .el-table__cell {
            text-align: center !important;
        }

        .descricao-item-tabela {
            margin-left: 55px;
            margin-right: 55px;
        }
    }

    .table-territorios {
        height: 100%;
        width: 100%;
        background-color: var(--white);
        border-radius: $default-border-radius;
        border-color: var(--default-border-color);
    }

    .table {
        overflow-x: auto;

        .tabela-rodape {
            height: 54px;
            background: var(--white);
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 14px 44% 10px 5px;
            border-radius: 0 0 5px 5px;
            margin-top: auto;

            .tabela-rodape--esquerda p {
                margin-bottom: 0;
                color: var(--primary);
                margin-left: 10px;
            }

            .tabela-rodape--pagination {
                .el-pager li.active {
                    color: var(--white);
                    font-weight: 900;
                    background: var(--primary);
                }

                .el-pager li {
                    padding: 0 4px;
                    background: var(--white);
                    vertical-align: top;
                    display: inline-block;
                    font-size: 13px !important;
                    min-width: 28px !important;
                    height: 28px !important;
                    line-height: 28px !important;
                    box-sizing: border-box;
                    text-align: center;
                    margin: 0;
                    border-radius: 2px;
                    color: var(--primary);
                }

                .el-pagination button {
                    height: 28px;
                }
            }
        }
    }

    .el-dialog__body {
        padding: 5px 20px;
        color: var(--text-disabled);
        font-size: 14px;
        word-break: break-all;
    }

    .buttons {
        width: 100%;
        gap: 16px;
        display: flex;
        justify-content: space-between;
    }

    .vw-100 {
        width: 100%;
    }

    .el-descriptions-item__container .el-descriptions-item__content {
        display: flex;
        flex-direction: column;
        column-count: 3;
    }

    .car-list-row {
        display: grid;
        grid-template-columns: auto auto auto;
        width: 100%;
        column-gap: 10px;
    }

    .car {
        display: flex;
    }

    .car-hiden-row {
        max-width: 55ch;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .el-descriptions-item__label.has-colon::after {
        content: '' !important;
    }
}
</style>

<style lang="scss">
.el-table td.el-table__cell {
    border: none !important;
}
</style>
